<label class="switch" [ngClass]="{'disabled' : disabled}">
    <input type="checkbox" [checked]="checked" [disabled]="disabled" (change)="onToggle()" />
    <span class="slider"></span>
</label>